import { rowOrder } from './rowOrder.model';

export class configuration {    
    public orderRowDataAlpha: String[];
    public rowOrderData: Array<rowOrder>;
    public dataToPrint: Array<any>;
} 